<template>
  <div id="createWave">
    <a-modal
      :title="$t('pubGicSet.AdvanceSearch')"
      v-model="AdvanceSearchVis"
      width="80%"
      @cancel="cancelAdvanceSearch">
      <a-row>
        <and-or :options="options" :isFirst="isFirst" ref="andOr"></and-or>
      </a-row>
      <template slot="footer">
        <a-row>
          <a-col :span="18">
            <a-row type="flex" justify="start">
              <a-col><span>{{ $t('publicLang.Template') }}: </span></a-col>
              <a-col>
                <a-select
                  size="small"
                  style="width: 120px"
                  :placeholder="$t('publicLang.Template')"
                  v-model="targetAdvanceTml"
                  @change="changeTamplateAdvace">
                  <a-select-option
                    :value="item"
                    v-for="item in AdvanceTemplate"
                    >{{ item }}</a-select-option
                  >
                </a-select>
              </a-col>
              <a-col style="margin: 0 4px">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ $t('generic.Add') }}</span>
                  </template>
                  <img @click="showAddTemplatName" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                </a-tooltip>
              </a-col>
              <a-col>
                <a-popconfirm
                  :title="$t('pubGicSet.AreyoudeleTask')"
                  :okText="$t('pubGicSet.Yes')"
                  :cancelText="$t('pubGicSet.No')"
                  @confirm="deleteTemplatName"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{ $t('pubGicSet.delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                  </a-tooltip>
                </a-popconfirm>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="6">
            <a-button type="primary" @click="getQueryFilter" size="small">{{ $t('pubGicSet.Search') }}</a-button>
          </a-col>
        </a-row>
      </template>
    </a-modal>
  </div>
</template>
<script>
import andOr from "./createWaveCops/AndOR.vue";
export default {
  components: {
    andOr
  },
  data() {
    return {
      AdvanceTemplate: [],
      targetAdvanceTml: "",
      AdvanceSearchVis: false,
      options: {
        // query filter 下拉
        condition: [],
        fieldNameSel: []
      },
      isFirst: true
    };
  },
  methods: {
    deleteTemplatName() {},
    getQueryFilter() {},
    showAddTemplatName() {},
    changeTamplateAdvace() {},
    cancelAdvanceSearch() {},
    open() {
      this.AdvanceSearchVis = true;
    },
    close() {
      this.AdvanceSearchVis = false;
    }
  }
};
</script>
